import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  DeleteCustomFieldWithinFieldsetInput,
  DeleteCustomFieldWithinFieldsetMutation,
} from '@/gql/graphql';

const DELETE_CUSTOM_FIELD_WITHIN_FIELDSET_MUTATION = graphql(`
  mutation DeleteCustomFieldWithinFieldset(
    $input: DeleteCustomFieldWithinFieldsetInput!
  ) {
    deleteCustomFieldWithinFieldset(input: $input) {
      id
      archivedAt
      identifier
      isRequired
      label
      type
      options
      schema
    }
  }
`);

const useDeleteCustomFieldWithinFieldset = (
  options?: UseMutationOptions<
    DeleteCustomFieldWithinFieldsetMutation,
    unknown,
    DeleteCustomFieldWithinFieldsetInput
  >
) => {
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(DELETE_CUSTOM_FIELD_WITHIN_FIELDSET_MUTATION, {
        input,
      });
    },
    ...options,
  });
};

export default useDeleteCustomFieldWithinFieldset;
